import {ShippingSizeData} from './data';
import s from './s';

export function updateShippingBoxID() {
    let id = -1;
    if (s.ps.docWidth > s.ps.docHeight) {
        const _t = s.ps.docHeight;
        s.ps.docHeight = s.ps.docWidth;
        s.ps.docWidth = _t;
    }

    try {
        let hit = false;
        for (let i = 0; i < ShippingSizeData.length; i++) {
            let ssd = ShippingSizeData[i];
            if (s.ps.docWidth <= ssd.width && s.ps.docHeight <= ssd.height) {
                id = ssd.id;
                hit = true;
                break;
            }
        }
        if (!hit) {
            id = 7;
        }
    } catch (err) {
        id = 1;
    }

    let box_id: number;
    if (s.prod.isShippingOversize) {
        switch (id) {
            case 1:
                box_id = 3;
                break;
            case 2:
            case 3:
                box_id = 4;
                break;
            case 4:
            case 5:
                box_id = 5;
                break;
            case 6:
                box_id = 6;
                break;
            default:
                box_id = 6;
                break;
        }
    } else {
        switch (id) {
            case 1:
                box_id = 1;
                break;
            case 2:
            case 3:
                box_id = 2;
                break;
            case 4:
            case 5:
                box_id = 3;
                break;
            case 6:
                box_id = 4;
                break;
            default:
                box_id = 5;
                break;
        }
    }
    s.ui.box_id = box_id;
}
